import { useTheme } from '@mui/material/styles';
import { useFormContext } from 'react-hook-form';

import Box from '~/common/components/Box';
import Checkbox from '~/common/components/Checkboxes/Checkbox/Checkbox';
import Flex from '~/common/components/Flex';

import QuestionLibraryErrorMessage from '../../components/utilityComponents/QuestionLibraryErrorMessage';
import type { QuestionLibraryError } from '../../utils/errorHandling';
import { useConditionsEvaluator } from '../../utils/useConditionsEvaluator';

type SimpleCheckboxProps = {
  field?: any;
  question?: Record<string, any>;
  error?: QuestionLibraryError;
  padding?: string;
};

export default function SimpleCheckbox({
  field,
  question,
  error,
  padding,
}: Readonly<SimpleCheckboxProps>) {
  const { name, conditions, label, rules } = question;
  const { setValue } = useFormContext();
  const { isDisabled } = useConditionsEvaluator(conditions ?? {});
  const theme = useTheme();

  return (
    <Flex direction={'column'} padding={padding}>
      <Checkbox
        isInvalid={error.hasError}
        name={name}
        data-testid={name}
        isChecked={field.value}
        isDisabled={isDisabled}
        aria-labelledby={`${name}-label`}
        {...field}
        onChange={(e) => {
          setValue(name, e.target.checked);
        }}
      >
        {label}{' '}
        {rules?.required && (
          <Box as="span" color={theme.palette.error.main}>
            *
          </Box>
        )}
      </Checkbox>
      {error.hasError && <QuestionLibraryErrorMessage error={error} />}
    </Flex>
  );
}
